import {Component, inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import {MatProgressBarModule} from "@angular/material/progress-bar";

@Component({
  selector: 'via-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
  imports: [MatProgressBarModule]
})
export class ProgressIndicatorComponent {
  data = inject(MAT_SNACK_BAR_DATA);

}
